import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { StaticPageLayout } from '../../components/shopper/StaticPageLayout';
import { Card, CardContent } from '../../components/ui/card';
import { BLOG_POSTS } from '../../content/site-pages';
import { ROUTES } from '../../constants/routes';

export function BlogPage() {
  return (
    <StaticPageLayout title="Blog" subtitle="Stories from Fash and our boutique partners">
      <div className="space-y-3">
        {BLOG_POSTS.map((post) => (
          <Card key={post.slug}>
            <CardContent className="p-0">
              <Link
                to={`${ROUTES.blog}/${post.slug}`}
                className="flex items-center justify-between p-5 hover:bg-gray-50 transition-colors group"
              >
                <div className="min-w-0 pr-4">
                  <p className="text-xs text-body mb-1">
                    {new Date(post.date).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </p>
                  <h2 className="font-medium text-heading group-hover:text-primary transition-colors">
                    {post.title}
                  </h2>
                  <p className="text-sm text-body mt-2 line-clamp-2">{post.excerpt}</p>
                </div>
                <ChevronRight className="h-5 w-5 text-gray-400 flex-shrink-0 group-hover:text-primary" />
              </Link>
            </CardContent>
          </Card>
        ))}
      </div>
    </StaticPageLayout>
  );
}
